import { createSlice } from "@reduxjs/toolkit";
import { getWelcomeAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getWelcomeSlice = createSlice({
  name: "getWelcomeSlice",
  initialState: data,
  reducers: {
        getWelcomeSliceInfo(state) {
      state.isLoading = true;
    },
    getWelcomeSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getWelcomeSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getWelcomeSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getWelcomeHandler = (data) => async (dispatch) => {
  try {
    dispatch(getWelcomeSliceAction.getWelcomeSliceInfo());
    const response = await getWelcomeAPI(data);
    dispatch(getWelcomeSliceAction.getWelcomeSliceSuccess(response));
  } catch (e) {
    	dispatch(getWelcomeSliceAction.getWelcomeSliceFailure(e));
  }
};
	export default getWelcomeSlice.reducer;
export const getWelcomeSliceAction = getWelcomeSlice.actions;
